"use client";

import { usePathname } from "next/navigation";
import React, { type ReactElement } from "react";
import { Footer } from "@oreme/ui";

function GlobalFooter(): ReactElement | null {
  const pathname = usePathname();
  const hiddenRoutes = ["/explore"];
  const isHidden = hiddenRoutes.includes(pathname);

  if (isHidden) return null;

  return <Footer />;
}

export { GlobalFooter };
